import { HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { NormalizedError } from '../../models/normalized-error/normalized-error.model';

export const normalizeError =
    (message: string) =>
    <T>(source$: Observable<T>) =>
        source$.pipe(
            catchError((error: unknown) =>
                throwError(() => {
                    if (error instanceof NormalizedError) {
                        return error;
                    } else if (error instanceof HttpErrorResponse) {
                        return new NormalizedError(message, {
                            cause: new Error(JSON.stringify(error.error)),
                        });
                    } else {
                        return new NormalizedError(message, {
                            cause: error,
                        });
                    }
                }),
            ),
        );
